export default {
    workflows: {
        title: "Flujos de Trabajo",
        description: "Gestiona flujos de trabajo personalizados para agentes de IA",
        newWorkflow: "Nuevo Flujo de Trabajo",
        searchPlaceholder: "Buscar por nombre...",
        statusPlaceholder: "Filtrar por estado",
        type: {
            default: "Predeterminado",
            custom: "Personalizado",
        },
        status: {
            draft: "Borrador",
            analyzing: "Analizando",
            ready: "Listo",
            needs_clarification: "Requiere Revisión",
            invalid: "No Válido",
            disabled: "Desactivado",
            // Legacy (for backwards compatibility)
            active: "Activo",
            inactive: "Inactivo",
        },
        headers: {
            name: "Nombre",
            type: "Tipo",
            status: "Estado",
            active: "Activo",
            nodesCount: "Nodos",
            lastAiEvaluation: "Última Validación AI",
            createdAt: "Creado",
            actions: "Acciones",
        },
        actions: {
            view: "Ver",
            edit: "Editar",
            delete: "Eliminar",
        },
        detail: {
            back: "Atrás",
            edit: "Editar",
            nodesCount: "Nodos",
            edgesCount: "Conexiones",
            createdAt: "Creado el",
            visualization: "Visualización del Flujo de Trabajo",
        },
        notFound: {
            title: "Flujo de Trabajo No Encontrado",
            message: "El flujo de trabajo solicitado no existe.",
            backToList: "Volver a la Lista",
        },
        noData: {
            title: "Sin Flujos de Trabajo",
            message: "Crea tu primer flujo de trabajo para comenzar.",
        },
        modal: {
            confirmDelete: "Eliminar Flujo de Trabajo",
            confirmDeleteMessage: "¿Estás seguro de que deseas eliminar este flujo de trabajo? Esta acción no se puede deshacer.",
        },
        new: {
            title: "Nuevo Flujo de Trabajo",
        },
        edit: {
            title: "Editar Flujo de Trabajo",
        },
        editor: {
            addNode: "Añadir Nodo",
            deleteNode: "Eliminar Nodo",
            cancel: "Cancelar",
            save: "Guardar",
            nodeProperties: "Propiedades del Nodo",
            nodeType: "Tipo",
            nodeLabel: "Etiqueta",
            agentType: "Tipo de Agente",
            actionType: "Tipo de Acción",
            condition: "Condición",
            nodeTypes: {
                start: "Nodo Inicio",
                agent: "Nodo Agente",
                decision: "Nodo Decisión",
                action: "Nodo Acción",
                email: "Nodo Email",
                end: "Nodo Fin",
            },
            defaultLabels: {
                start: "Inicio",
                agent: "Agente",
                decision: "Decisión",
                action: "Acción",
                email: "Email",
                end: "Fin",
            },
            agentTypes: {
                postino: "Correo/Cartero",
                classificatore: "Clasificador",
                parser: "Analizador",
                validatore: "Validador",
            },
            actionTypes: {
                notification_in_app: "Notificación In-App",
                notification_email: "Notificación Email",
                notification_both: "Notificación Completa",
            },
            operators: {
                equals: "Igual",
                contains: "Contiene",
                exists: "Existe",
                not_equals: "No Igual",
                not_contains: "No Contiene",
            },
            savingWorkflow: "Guardando flujo de trabajo...",
            workflowSaved: "¡Flujo de trabajo guardado con éxito!",
            relatedAccounts: "Cuentas Relacionadas",
            searchAccounts: "Buscar cuentas por nombre, email o NIF...",
            noAccountsFound: "No se encontraron cuentas",
            taxId: "NIF",
            selectedCount: "{{count}} seleccionadas",
            close: "Cerrar",
            instructions: "Instrucciones (Lenguaje Natural)",
            instructionsPlaceholder: "Describe la condición o acción en lenguaje natural...",
            edgeProperties: "Propiedades de Conexión",
            edgeLabel: "Etiqueta",
            edgeLabelPlaceholder: "Ingresa etiqueta para la conexión...",
            deleteEdge: "Eliminar Conexión",
            closeSidebar: "Cerrar panel",
            openSidebar: "Abrir panel",
            workflowProperties: "Propiedades del Flujo de Trabajo",
            status: "Estado",
            isActive: "Activo",
            isDefault: "Flujo Predeterminado",
            evaluate: "Evaluar",
            evaluating: "Evaluando...",
            agentDefault: "Predeterminado",
            agentSelector: {
                placeholder: "Selecciona un agente...",
                searchPlaceholder: "Buscar agente por nombre, descripción...",
                filters: {
                    all: "Todos",
                    defaultOnly: "Solo predeterminados",
                },
                noResults: "No se encontraron agentes",
                tools: "{{count}} herramientas",
                ragSources: "{{count}} fuentes RAG",
            },
            aiFeedback: {
                title: "Resultados de Evaluación AI",
                analyzedAt: "Analizado el",
                nodeId: "Nodo",
                suggestions: "Sugerencias",
                noFeedback: "No hay feedback disponible. Haz clic en 'Evaluar' para analizar este flujo de trabajo.",
            },
            // Email Node
            emailNodeTemplateFilter: "Filtro de plantilla",
            emailNodeFilterSystem: "Solo plantillas de sistema",
            emailNodeFilterCompany: "Plantillas por empresa",
            emailNodeSelectTemplate: "Seleccionar plantilla",
            emailNodeCompany: "Empresa",
            emailNodeSelectCompany: "Seleccionar empresa...",
            emailNodeRules: "Reglas (lenguaje natural)",
            emailNodeRulesPlaceholder: "Describe las reglas a seguir para este envío de email...",
            emailNodeTo: "Destinatarios (opcional)",
            emailNodeToPlaceholder: "ej. {{context.email_to}} o direcciones separadas por comas",
        },
        savingChanges: "Guardando cambios...",
        allSaved: "¡Todo guardado!",
    },
};
